import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { PontosCriticosTipos } from '../../models/pontos-criticos-tipos.model';
import { NavigationService } from '../../services/navigation.service';
import { PontosCriticosTiposService } from '../../services/pontos-criticos-tipos.service';

@Component({
  selector: 'app-pontos-criticos-tipos-list',
  templateUrl: './pontos-criticos-tipos-list.component.html',
  styleUrls: ['./pontos-criticos-tipos-list.component.scss']
})
export class PontosCriticosTiposListComponent extends BaseListComponent<PontosCriticosTipos> implements OnInit, OnDestroy {

  pontoList: PontosCriticosTipos[];

  constructor(
    private myService: PontosCriticosTiposService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super();
  }

  ngOnInit() {
    this.initLoadDataTable();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.findAll().subscribe((res) => {
        this.pontoList = res;
        this.loaded();
      })
    );
  }

  novo() {
    return ['/projetos/admin-spgg/pontos-criticos-tipos/adicionar'];
  }

  confirmExcluir(id: number) {
    this.alertConfirmation(id).subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: number): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message)
      }
    });
  }

  editar(id: number) {
    return ['/projetos/admin-spgg/pontos-criticos-tipos/', id];
  }

}
